const actions = {
  VOLUNTEER_CATEGORY_ADD_BEGIN: 'VOLUNTEER_CATEGORY_ADD_BEGIN',
  VOLUNTEER_CATEGORY_ADD_SUCCESS: 'VOLUNTEER_CATEGORY_ADD_SUCCESS',
  VOLUNTEER_CATEGORY_ADD_ERR: 'VOLUNTEER_CATEGORY_ADD_ERR',
  
  VOLUNTEER_CATEGORIES_READ_BEGIN: 'VOLUNTEER_CATEGORIES_READ_BEGIN',
  VOLUNTEER_CATEGORIES_READ_SUCCESS: 'VOLUNTEER_CATEGORIES_READ_SUCCESS',
  VOLUNTEER_CATEGORIES_READ_ERR: 'VOLUNTEER_CATEGORIES_READ_ERR',

  VOLUNTEER_CATEGORY_UPDATE_BEGIN: 'VOLUNTEER_CATEGORY_UPDATE_BEGIN',
  VOLUNTEER_CATEGORY_UPDATE_SUCCESS: 'VOLUNTEER_CATEGORY_UPDATE_SUCCESS',
  VOLUNTEER_CATEGORY_UPDATE_ERR: 'VOLUNTEER_CATEGORY_UPDATE_ERR',

  VOLUNTEER_CATEGORY_DELETE_BEGIN: 'VOLUNTEER_CATEGORY_DELETE_BEGIN',
  VOLUNTEER_CATEGORY_DELETE_SUCCESS: 'VOLUNTEER_CATEGORY_DELETE_SUCCESS',
  VOLUNTEER_CATEGORY_DELETE_ERR: 'VOLUNTEER_CATEGORY_DELETE_ERR',

  VOLUNTEER_CATEGORY_READ_BEGIN: 'VOLUNTEER_CATEGORY_READ_BEGIN',
  VOLUNTEER_CATEGORY_READ_SUCCESS: 'VOLUNTEER_CATEGORY_READ_SUCCESS',
  VOLUNTEER_CATEGORY_READ_ERR: 'VOLUNTEER_CATEGORY_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.VOLUNTEER_CATEGORIES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.VOLUNTEER_CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.VOLUNTEER_CATEGORIES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.VOLUNTEER_CATEGORY_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.VOLUNTEER_CATEGORY_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.VOLUNTEER_CATEGORY_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.VOLUNTEER_CATEGORY_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.VOLUNTEER_CATEGORY_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.VOLUNTEER_CATEGORY_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.VOLUNTEER_CATEGORY_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.VOLUNTEER_CATEGORY_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.VOLUNTEER_CATEGORY_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.VOLUNTEER_CATEGORY_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.VOLUNTEER_CATEGORY_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.VOLUNTEER_CATEGORY_READ_ERR,
      err,
    };
  },

};

export default actions;
